const body = document.querySelector('body');
function productGridChanger () {
  if (body.classList.contains('collection')){
    const firstColumn = document.querySelector('.grid-view-first-column');
    const secondColumn = document.querySelector('.grid-view-second-column');
    const thirdColumn = document.querySelector('.grid-view-third-column');
    const firstColumnMobile = document.querySelector('.grid-view-first-column-mobile');
    const secondColumnMobile = document.querySelector('.grid-view-second-column-mobile');
    
    const gridView = document.querySelector('#ProductGridContainer #product-grid');
    
    firstColumn.addEventListener('click', function() {
        gridView.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');
        gridView.classList.add('grid--2-col-desktop');
        removeActiveClass();
        firstColumn.classList.add('active');
    });
    
    secondColumn.addEventListener('click', function() {
        gridView.classList.remove('grid--2-col-desktop', 'grid--4-col-desktop');
        gridView.classList.add('grid--3-col-desktop');
        removeActiveClass();
        secondColumn.classList.add('active');
    });
    
    thirdColumn.addEventListener('click', function() {
        gridView.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop');
        gridView.classList.add('grid--4-col-desktop');
        removeActiveClass();
        thirdColumn.classList.add('active');
    });

     firstColumnMobile.addEventListener('click', function() {
       console.log("you are clicking on first div")
        gridView.classList.remove('grid--2-col-tablet-down');
        gridView.classList.add('grid--1-col-tablet-down');
        firstColumnMobile.classList.add('Active');
        secondColumnMobile.classList.remove('Active');
    });

     secondColumnMobile.addEventListener('click', function() {
        gridView.classList.remove('grid--1-col-tablet-down');
        gridView.classList.add('grid--2-col-tablet-down');
        firstColumnMobile.classList.remove('Active');
        secondColumnMobile.classList.add('Active');
    });
    
    function removeActiveClass() {
      const gridViewChangers = document.querySelectorAll('.grid-view-changer');  
      gridViewChangers.forEach(element => {
        element.classList.remove('active');
      });
    }
  }
}

function checkActiveGridView() {
  const activeGridView = document.querySelector('.grid-view-changer.active');
  const gridView = document.querySelector('#ProductGridContainer #product-grid');

  if (activeGridView) {
    const firstColumn = activeGridView.classList.contains('grid-view-first-column');
    const secondColumn = activeGridView.classList.contains('grid-view-second-column');
    const thirdColumn = activeGridView.classList.contains('grid-view-third-column'); 
    const firstColumnMobile = activeGridView.classList.contains('grid-view-first-column-mobile'); 
    const secondColumnMobile = activeGridView.classList.contains('grid-view-second-column-mobile'); 

    if (firstColumn) {
      removeAnimationClass();
      gridView.classList.remove('grid--3-col-desktop');
      gridView.classList.add('grid--2-col-desktop');
    } else if (secondColumn) {
      removeAnimationClass();
      gridView.classList.remove('grid--2-col-desktop');
      gridView.classList.add('grid--3-col-desktop');
    } else if (thirdColumn) {
      removeAnimationClass();
      gridView.classList.remove('grid--2-col-desktop');
      gridView.classList.add('grid--4-col-desktop');
    }
    else if (firstColumnMobile) {
      removeAnimationClass();
      gridView.classList.remove('grid--2-col-tablet-down');
      gridView.classList.add('grid--1-col-tablet-down');
    }
    else if (secondColumnMobile) {
      removeAnimationClass();
      gridView.classList.remove('grid--1-col-tablet-down');
      gridView.classList.add('grid--2-col-tablet-down');
    }
  }

  function removeAnimationClass() {
    const gridItems = document.querySelectorAll('#product-grid li.grid__item');
  
    gridItems.forEach(element => {
      element.classList.remove('scroll-trigger--cancel');
    });
  }  
}


productGridChanger ();

if (body.classList.contains('collection')){

  function initMobileProductCardSliders() {
    const mobileProductCardSlider = document.querySelectorAll('.splide--mobile');
    
    if (mobileProductCardSlider) {
      var elms = mobileProductCardSlider;
      for ( var i = 0; i < elms.length; i++ ) {
        var splide = new Splide(elms[i], {      
            arrows  : true,
            pagination: false
          } );
        splide.mount();
      }
    }
  }
  
  initMobileProductCardSliders();

  function initializeSlidersForNewItems(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const newGridItems = document.querySelectorAll('ul#product-grid li.grid__item:not(.initialized)');
        if (newGridItems.length > 0) {
          newGridItems.forEach(item => {
            item.classList.add('initialized');
            const sliderContainer = item.querySelector('.splide--mobile');
            if (sliderContainer) {
              var splide = new Splide(sliderContainer, {
                arrows: true,
                pagination: false
              });
              splide.mount();
            }
          });
        }
      }
    }
  }
  
  // Observe mutations in the ul#product-grid
  const productGrid = document.getElementById('product-grid');
  const observer = new MutationObserver(initializeSlidersForNewItems);
  if (observer) {
    observer.observe(productGrid, { childList: true, subtree: true });
  }
}


// const toggleButton = document.querySelector('.sub-collection-links-heading');
// const elementToToggle = document.querySelector('.sub-collection-links');

// toggleButton.addEventListener('click', function() {
//   elementToToggle.classList.toggle('active');
// });
